module.exports = __webpack_public_path__ + "static/media/admission-process.eb8e476e.png";